import Contact2 from './Contact2'
export default Contact2
